<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">Rejection Reason</h4>

    <div mat-dialog-content class="dialog-content text-muted">
        {{ data.reason || 'No reason provided' }}
    </div>

    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="dialogRef.close()">
            Close
        </button>
    </div>
</div>